export const REFETCH_INTERVAL = 120000;
